import React, { useRef } from 'react';
import { ClassNames } from '@emotion/core';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import Carousel from '@domain-group/fe-co-carousel';
import { SmallCard } from '../small-card';
import * as styles from './carousel-slide.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CarouselSlide = _ref => {
  var _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    maxColumns = _ref.maxColumns,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Property of the Week' : _ref$title,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var indexBox = useRef(null);
  var setActiveIndex = (prevIndex, newIndex) => {
    if (prevIndex !== newIndex && indexBox.current) {
      indexBox.current.innerHTML = "".concat(newIndex + 1);
    }
  };
  var displayedListings = listings.slice(0, maxColumns);
  return ___EmotionJSX(ClassNames, null, _ref2 => {
    var css = _ref2.css;
    return ___EmotionJSX("div", null, ___EmotionJSX(Carousel, {
      autoplay: false,
      autoplaySpeed: 5000,
      infinite: true,
      dots: true,
      dotsClass: css(styles.carouselDots),
      arrows: false,
      slidesToShow: 1,
      beforeChange: setActiveIndex
    }, displayedListings.map((listing, index) => ___EmotionJSX("div", {
      key: listing.url
    }, ___EmotionJSX(SmallCard, {
      title: title,
      onClick: () => {
        sendEvent('pow-click', {
          slideType: 'carousel',
          listing,
          index
        });
        _onClick(listing, index);
      },
      listing: listing
    })))), ___EmotionJSX("div", {
      css: styles.sliderPage
    }, ___EmotionJSX("span", {
      ref: indexBox
    }, "1"), "/", listings.length));
  });
};
export { CarouselSlide };